
/* ==========================================================================
   PREMIUM FEATURES - Vitamin Shoppe Emulation Pack
   ========================================================================== */

// === FREE SHIPPING BAR REFRESH AFTER CART CHANGES ===
let _freeShippingFetchId = 0;
let _freeShippingAbortController = null;

function refreshFreeShippingBars(){
  const fetchId = ++_freeShippingFetchId;

  if (_freeShippingAbortController) {
    _freeShippingAbortController.abort();
  }
  _freeShippingAbortController = new AbortController();

  return fetch('/cart.js', { signal: _freeShippingAbortController.signal, cache: 'no-store' }).then(r=>r.json()).then(cart=>{
    if (fetchId !== _freeShippingFetchId) return;

    document.querySelectorAll('.free-shipping-bar').forEach(el=>{
      const subtotalCents = Number(cart.items_subtotal_price ?? cart.total_price ?? 0);
      const thresholdRaw = Number(el.dataset.freeShippingThresholdCents || 5000);
      const thresholdCents = Number.isFinite(thresholdRaw) && thresholdRaw > 0 ? thresholdRaw : 5000;
      const remainingCents = Math.max(0, thresholdCents - subtotalCents);
      const isQualified = remainingCents <= 0;

      const msgEl = el.querySelector('.free-shipping-bar__text');
      if (msgEl) {
        msgEl.classList.toggle('free-shipping-bar__text--success', isQualified);
        const remainingLabel = (window.Shopify && typeof window.Shopify.formatMoney === 'function')
          ? window.Shopify.formatMoney(remainingCents)
          : `$${(remainingCents / 100).toFixed(2)}`;

        msgEl.innerHTML = isQualified
          ? "<span aria-hidden=\"true\">✓</span><span>You've qualified for <strong>FREE SHIPPING</strong>!</span>"
          : `<span aria-hidden="true">🚚</span><span>Add <strong>${remainingLabel}</strong> more for <strong>FREE SHIPPING</strong></span>`;
      }

      const pct = Math.min(100, Math.max(0, (subtotalCents / thresholdCents) * 100));
      const progressEl = el.querySelector('.free-shipping-bar__progress');
      const progressBarEl = el.querySelector('.free-shipping-bar__progress-bar');
      if (progressEl) progressEl.setAttribute('aria-valuenow', pct.toFixed(2));
      if (progressBarEl) progressBarEl.style.width = `${pct}%`;
    });
  }).catch(err => {
    if (err && err.name === 'AbortError') return;
    console.error('Free shipping bar refresh error:', err);
  }).finally(() => {
    if (fetchId === _freeShippingFetchId) {
      _freeShippingAbortController = null;
    }
  });
}
window.refreshFreeShippingBars = refreshFreeShippingBars;

// === WISHLIST (LOCALSTORAGE) ===
const WL_KEY = 'rv_wishlist';
function getWishlist(){ try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch { return []; } }
function setWishlist(list){
  try {
    localStorage.setItem(WL_KEY, JSON.stringify(Array.from(new Set(list))));
  } catch (err) {
    console.error('Wishlist storage error:', err);
  }
}

function applyWishlistButtonState(btn, isActive){
  btn.classList.toggle('is-active', !!isActive);
  btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  const activeLabel = btn.dataset.wishlistLabelActive || 'Remove from saved items';
  const inactiveLabel = btn.dataset.wishlistLabelInactive || 'Save for later';
  btn.setAttribute('aria-label', isActive ? activeLabel : inactiveLabel);
}

document.addEventListener('click', (e)=>{
  const btn = e.target.closest('.wishlist-btn');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();

  const handle = btn.dataset.wishlistHandle;
  if (!handle) return;

  const list = getWishlist();
  const i = list.indexOf(handle);
  i>=0 ? list.splice(i,1) : list.push(handle);
  setWishlist(list);
  const isActive = i < 0;
  applyWishlistButtonState(btn, isActive);
  toast(isActive ? 'Saved to Wishlist' : 'Removed from Wishlist');
});

// Restore wishlist state on page load
document.addEventListener('DOMContentLoaded', ()=>{
  const list = getWishlist();
  document.querySelectorAll('.wishlist-btn').forEach(btn=>{
    const isActive = list.includes(btn.dataset.wishlistHandle);
    applyWishlistButtonState(btn, isActive);
  });
});

// Toast on confirmed add-to-cart (cart domain fires rv:add-to-cart-success after
// the /cart/add.js response is received; avoids racy setTimeout approach).
document.addEventListener('rv:add-to-cart-success', () => toast('Added to cart'));

// Refresh on explicit cart update events from theme scripts.
document.addEventListener('rv:cart-updated', () => {
  refreshFreeShippingBars();
});
function toast(msg){
  let n = document.querySelector('.rv-toast');
  if(!n){
    n = document.createElement('div');
    n.className = 'rv-toast';
    document.body.appendChild(n);
  }
  n.textContent = msg;
  n.classList.add('show');
  setTimeout(()=>n.classList.remove('show'), 2000);
}

// === SIMPLE CLIENT SEARCH (MOCK FILTERING) ===
(function(){
  const input = document.querySelector('[data-search-input]');
  if(!input) return;

  // Debounce search
  let searchTimeout;
  input.addEventListener('input', ()=>{
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      const q = input.value.trim().toLowerCase();
      document.querySelectorAll('[data-product-handle]').forEach(card=>{
        const t = (card.dataset.productTitle || '').toLowerCase();
        card.style.display = (!q || t.includes(q)) ? '' : 'none';
      });
    }, 150);
  });
})();

// === SCROLL REVEAL ===
(function(){
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if(e.isIntersecting){
        e.target.classList.add('revealed');
        io.unobserve(e.target);
      }
    });
  },{threshold:0.1});
  document.querySelectorAll('.fade-up').forEach(el=>io.observe(el));
})();

// === PARALLAX HINT FOR HERO GRADIENT ===
document.addEventListener('scroll', ()=> {
  const r = document.querySelector('.hero-gradient');
  if (r) r.style.setProperty('--scroll', String(window.scrollY||0));
},{passive:true});
